import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { ResponsiveContext, Box, Text, Button } from 'grommet';
import { DownloadOption, Calendar, User, Search, Projects } from 'grommet-icons';

import rulesName from '../../../../constants/rules';
import urlRoutes from '../../../../config/url-routes';

const OnboardingComponent = (props) => {
  const {
    userLogged: { rules },
    history,
  } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          direction='row'
          justify='center'
          margin={{ horizontal: 'medium', top: '100px' }}
        >
          <Box
            pad='small'
            width='xlarge'
            gap='medium'
          >

            {/* Cabeçalho */}
            <Box
              direction='row'
              gap='xsmall'
              align='baseline'
            >
              <Text size='large' color='dark-5'>Bem-vindo ao módulo de</Text>
              <Text size='xlarge' color='dark-1'>eleitores.</Text>
            </Box>

            {/* Conteúdo */}
            <Box
              gap='medium'
              direction={ size === 'small' || size === 'medium' ? 'column' : 'row' }
              justify='between'
            >
              {/* Primeira coluna */}
              <Box
                width={
                  size === 'small' || size === 'medium' ? 'xlarge' : 'xlarge'
                }
              >
                <Box
                  margin={{
                    bottom: size === 'small' ? 'large' : 'medium'
                  }}
                >
                  <Text color='dark-2' size='small'>
                    Aqui você cadastra aquela pessoa que foi até seu gabinete, escritório de trabalho, etc.
                    Também é possível realizar diversas outras ações.
                  </Text>
                </Box>

                <Box
                  direction='row'
                  gap={ size === 'small' ? 'large' : 'medium' }
                  margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                >
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <User size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Gerencie seus cadastros
                    </Text>

                    <Text size='small' color='dark-2'>
                      Cadastre, edite e exclua os cadastros.
                      Aqui você têm liberdade para atuar.
                    </Text>
                  </Box>

                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <DownloadOption size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Imprima e exporte
                    </Text>

                    <Text size='small' color='dark-2'>
                      Imprima ou exporte a lista de pessoas cadastradas com um clique!
                    </Text>
                  </Box>
                </Box>

                <Box
                  direction='row'
                  gap={ size === 'small' ? 'large' : 'medium' }
                  margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                >
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Calendar size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Crie lembretes
                    </Text>

                    <Text size='small' color='dark-2'>
                      Imagina que precisa ligar para um de seus cadastros daqui a 10 dias.
                      Com um lembrete, você garante que não vai esquecer!
                    </Text>
                  </Box>

                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Search size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Busca avançada
                    </Text>

                    <Text size='small' color='dark-2'>
                      Filtre as pessoas cadastradas por bairro, cidade, grupo, gênero e muito mais.
                    </Text>
                  </Box>
                </Box>

                <Box
                  direction='row'
                  gap={ size === 'small' ? 'large' : 'medium' }
                  margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                >
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Projects size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Gere etiquetas
                    </Text>

                    <Text size='small' color='dark-2'>
                      Uma forma fácil e rápida de gerar etiquetas para enviar correspondências.
                    </Text>
                  </Box>

                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  />
                </Box>
              </Box>

              {/* Separador coluna */}
              <Box
                width={ size === 'large' || size === 'xlarge' ? 'xsmall' : 'xxsmall'}
              />

              {/* Segunda coluna */}
              <Box
                gap='small'
                width={ size === 'small' || size === 'medium' ? 'xlarge' : 'xlarge' }
              >
                <Box
                  gap='medium'
                  round='small'
                  border={{ color: 'light-4' }}
                  pad={{
                    vertical: size === 'small' ? 'large' : 'medium',
                    horizontal:  size === 'small' ? 'medium' : 'small',
                  }}
                >
                  <Text color='dark-2' size='small'>
                    Os cadastros são a base do sistema, a partir dele é possível criar um atendimento,
                    enviar SMS e muito mais.
                  </Text>

                  <Button
                    primary
                    label='Começar, Cadastrar alguém'
                    color='neutral-1'
                    title={!rules.includes(rulesName.createVoter) ? 'Você não tem permissão para cadastrar pessoas.' : null }
                    disabled={!rules.includes(rulesName.createVoter)}
                    onClick={() =>
                      history.push(urlRoutes.voterCreateUrl)
                    }
                  />
                </Box>

                {/*<Text color='dark-2' size='small'>
                  Caso tenha alguma dúvida entre em contato por WhatsApp ou e-mail.
                </Text>

                <Box>
                  <Text color='dark-2' size='small'>Suporte por WhatsApp</Text>
                </Box>*/}

              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  );
};

const mapStateToProps = ({ authReducer: { authenticated } }) => ({
  userLogged: authenticated,
});

const mapDispatchToProps = null;

export const Onboarding = withRouter(connect(mapStateToProps, mapDispatchToProps)(OnboardingComponent));
